'use client';

import isNewConsumerApp from 'commons/isNewConsumerApp';

import AdvancedSearchNext from '../advanced-search-next';
import AdvancedSearchLegacy from './AdvancedSearchLegacy';

const AdvancedSearchAdapter = isNewConsumerApp
  ? AdvancedSearchNext
  : AdvancedSearchLegacy;

export default AdvancedSearchAdapter;
